const countdownEls = document.querySelectorAll('[data-countdown]');

if (countdownEls.length) {
    const DAY = 24 * 60 * 60 * 1000;
    const HOUR = 60 * 60 * 1000;
    const MINUTE = 60 * 1000;

    const pad = (n) => String(n).padStart(2, '0');

    const update = () => {
        countdownEls.forEach((el) => {
            const target = Number(el.dataset.countdown);
            if (!target) return;

            let diff = Math.max(0, target - Date.now());

            const days = Math.floor(diff / DAY);
            diff -= days * DAY;
            const hours = Math.floor(diff / HOUR);
            diff -= hours * HOUR;
            const minutes = Math.floor(diff / MINUTE);
            diff -= minutes * MINUTE;
            const seconds = Math.floor(diff / 1000);

            el.textContent = `${days}:${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
        });
    };

    update();
    setInterval(update, 1000);
}
